<template>
  <div class="input">
    <div class="input-label">回答時間</div>
    <div class="input-group">
      <input
        type="number"
        min="0"
        max="59"
        class="input-text"
        v-model="closeTime"
        disabled
        >
      <div class="input-label_after">分</div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    closeTime: {
      get: function () {
        return this.$store.state.eventClosed.closeTime
      },

      set: function (value) {
        this.$store.commit(
          'eventClosed/setCloseTime',
          value
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss';
</style>
